import alert from '@/plugins/alert'
import { Upload, Lesson } from '@/plugins/api'
import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    sessions: {
      // sessionId: {
      //  ...session,
      //  lessons : []
      // }
    },
    count: 0
  },
  actions: {
    async fetchSessions ({ commit }, options) {
      commit('setSessions', await Lesson.fetch(options))
    },
    async countSessions ({ commit }, options) {
      try {
        commit('setCount', await Lesson.count(options))
      } catch (e) {
        alert.error(e)
      }
    },
    async fetchSession ({ commit }, sessionId) {
      commit('setSessions', [await Lesson.fetchOne(sessionId)])
    },
    async createSession ({ commit }, { data, options }) {
      try {
        if (data.type === 'course-session') {
          commit('setSessions', [await Lesson.create(data, options)])
        } else {
          commit('setSessionsChild', await Lesson.create(data, options))
        }
        alert.success('Tạo thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateSession ({ commit, state }, { id, ...session }) {
      try {
        commit('setSessions', [await Lesson.update(id, session)])
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async removeSession ({ commit }, id) {
      try {
        await Lesson.remove(id)
        commit('removeSession', id)
        alert.success('Xóa bài học thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async removeLesson ({ commit }, lesson) {
      try {
        await Lesson.remove(lesson.id)
        commit('removeLesson', lesson)
        alert.success('Xóa bài học thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateLesson ({ commit }, { id, ...lesson }) {
      try {
        commit('updateLesson', await Lesson.update(id, lesson))
        alert.success('Xóa bài học thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    setSession ({ commit, state }, session) {
      commit('setSession', session)
    },
    async removeSessions ({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeSession', item.id)
      }
    },
    async createLesson ({ commit }, { data, options }) {
      try {
        commit('setLesson', await Lesson.create(data, options))
        alert.success('Tạo mới bài học thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async uploadAvatar ({ commit }, { sessionId, formData }) {
      try {
        let data = await Upload.upload(formData)
        commit('setAvatar', { sessionId, avatar: data[0] })
        alert.success('Upload successfully!')
      } catch (e) {
        alert.error(e)
      }
    },
    async destroyAvatar ({ commit }, id) {
      try {
        await Upload.destroy(id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setSessions (state, sessions) {
      state.sessions = sessions.reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue.id]: currentValue
        }),
        state.sessions
      )
    },
    setLesson (state, lesson) {
      const lessons = _.get(state.sessions, `${lesson.session.id}.lessons`, [])
      _.set(state.sessions, `${lesson.session.id}.lessons`, [
        ...lessons,
        lesson
      ])
      state.sessions = {
        ...state.sessions
      }
    },
    removeSession (state, sessionId) {
      delete state.sessions[sessionId]
      state.sessions = { ...state.sessions }
    },
    removeLesson (state, lesson) {
      const lessons = _.get(
        state.sessions,
        `${lesson.session}.lessons`,
        []
      ).filter(index => index.id !== lesson.id)
      _.set(state.sessions, `${lesson.session}.lessons`, lessons)
      state.sessions = {
        ...state.sessions
      }
    },
    updateLesson (state, lesson) {
      const lessons = _.get(state.sessions, `${lesson.session.id}.lessons`, [])
      const i = lessons.findIndex(d => d.id === lesson.id)
      if (i > -1) {
        lessons.splice(i, 1, lesson)
      } else {
        lessons.unshift(lesson)
      }
      _.set(state.sessions, `${lesson.session.id}.lessons`, lessons)
      state.sessions = {
        ...state.sessions
      }
    },
    setAvatar (state, { sessionId, avatar }) {
      _.set(state.sessions, `${sessionId}.avatar`, avatar)
      state.sessions = { ...state.sessions }
    }
  },
  getters: {
    sessions: state => {
      return Object.values(state.sessions)
    },
    session: state => id => {
      return state.sessions[id]
    },
    lessons: state => sessonId => {
      return _.get(state.sessions, `${sessonId}.lessons`) || []
    },
    count: state => {
      return state.count
    }
  }
}
